import React from 'react';
import { Form } from 'semantic-ui-react';
import { Label } from './label';
import ControlBoxSelector from '../../widgets/control-box-selector';
import { FieldError } from './field-error';
import { setupField } from '../utils/form-utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ControlBoxField(props: any) {
  const { handleBlur, handleChange, field, error } = setupField(props);
  return (
    <Form.Field inline>
      <Label>CBX</Label>
      <ControlBoxSelector {...field} onChange={handleChange} onBlur={handleBlur} error={error} />
      <FieldError {...props}></FieldError>
    </Form.Field>
  );
}
